var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-view"},[_c('form-view',{ref:_vm.meta['name'],attrs:{"meta":_vm.meta},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var model = ref.model;
var conf = ref.conf;
return [_vm._t("action",null,{"model":model,"conf":conf})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }